export default {
    methods: {
        setTitlePage(title, prefix) {
            const prefixDefault = 'LEADS | ';
            document.title = (prefix || prefixDefault) + title;
        },
    },
};
